import React, { Fragment, useState } from "react";
import { Card, Col } from 'react-bootstrap';
import '../../../../styles/leis-auth.scss'

const Licitante = (props) => {


    return (
        <Fragment>
            <Col>
                <Card className="card-list">
                    <Card.Body>
                        <Card.Text>
                            <p><strong>Licitante: </strong>{props.licitante.contratado}</p>
                            <p><strong>CNPJ: </strong>{props.licitante.cnpj}</p>
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Col>
        </Fragment >)
}

export default Licitante;